"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateStoreManager = exports.TemplateState = void 0;
var ContractBase_1 = __importDefault(require("../ContractBase"));
var utils_1 = require("../../../utils");
var TemplateState;
(function (TemplateState) {
    TemplateState[TemplateState["Uninitialized"] = 0] = "Uninitialized";
    TemplateState[TemplateState["Proposed"] = 1] = "Proposed";
    TemplateState[TemplateState["Approved"] = 2] = "Approved";
    TemplateState[TemplateState["Revoked"] = 3] = "Revoked";
})(TemplateState = exports.TemplateState || (exports.TemplateState = {}));
var TemplateStoreManager = (function (_super) {
    __extends(TemplateStoreManager, _super);
    function TemplateStoreManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplateStoreManager.getInstance = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var templateStoreManeger;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        templateStoreManeger = new TemplateStoreManager('TemplateStoreManager');
                        return [4, templateStoreManeger.init(config)];
                    case 1:
                        _a.sent();
                        return [2, templateStoreManeger];
                }
            });
        });
    };
    TemplateStoreManager.prototype.generateId = function (templateName) {
        var _a;
        var args = [{ type: 'string', value: templateName }];
        return (_a = this.web3.utils).soliditySha3.apply(_a, args);
    };
    TemplateStoreManager.prototype.getOwner = function () {
        return this.call('owner', []);
    };
    TemplateStoreManager.prototype.proposeTemplate = function (templateId, from, ignoreExists) {
        return __awaiter(this, void 0, void 0, function () {
            var template;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getTemplate(templateId)];
                    case 1:
                        template = _a.sent();
                        if (template.blockNumberUpdated !== 0) {
                            this.logger.warn("Template \"" + templateId + "\" already exist.");
                            if (!ignoreExists) {
                                throw new Error('Template already exist.');
                            }
                        }
                        else {
                            return [2, this.sendFrom('proposeTemplate', [utils_1.zeroX(templateId)], from)];
                        }
                        return [2];
                }
            });
        });
    };
    TemplateStoreManager.prototype.approveTemplate = function (templateId, from, ignoreApproved) {
        return __awaiter(this, void 0, void 0, function () {
            var template;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getTemplate(templateId)];
                    case 1:
                        template = _a.sent();
                        if (template.state !== TemplateState.Proposed) {
                            this.logger.warn("Template \"" + templateId + "\" is not in \"proposed\" state.");
                            if (!ignoreApproved) {
                                throw new Error("Template not in \"proposed\" state.");
                            }
                        }
                        else {
                            return [2, this.sendFrom('approveTemplate', [utils_1.zeroX(templateId)], from)];
                        }
                        return [2];
                }
            });
        });
    };
    TemplateStoreManager.prototype.revokeTemplate = function (templateId, from) {
        return this.sendFrom('revokeTemplate', [utils_1.zeroX(templateId)], from);
    };
    TemplateStoreManager.prototype.getConditionTypes = function (templateId) {
        return __awaiter(this, void 0, void 0, function () {
            var conditionTypes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getTemplate(templateId)];
                    case 1:
                        conditionTypes = (_a.sent()).conditionTypes;
                        return [2, conditionTypes];
                }
            });
        });
    };
    TemplateStoreManager.prototype.getConditions = function (conditionTypes) {
        var _this = this;
        return conditionTypes.map(function (address) {
            return _this.ocean.keeper.getConditionByAddress(address);
        });
    };
    TemplateStoreManager.prototype.getActorTypeValue = function (actorTypeId) {
        return __awaiter(this, void 0, void 0, function () {
            var typeValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.call('getTemplateActorTypeValue', [actorTypeId])];
                    case 1:
                        typeValue = _a.sent();
                        return [2, typeValue];
                }
            });
        });
    };
    TemplateStoreManager.prototype.getTemplate = function (templateId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, state, owner, lastUpdatedBy, blockNumberUpdated, conditionTypes, actorTypeIds;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.call('getTemplate', [utils_1.zeroX(templateId)])];
                    case 1:
                        _a = _b.sent(), state = _a.state, owner = _a.owner, lastUpdatedBy = _a.lastUpdatedBy, blockNumberUpdated = _a.blockNumberUpdated, conditionTypes = _a.conditionTypes, actorTypeIds = _a.actorTypeIds;
                        return [2, {
                                state: +state,
                                owner: owner,
                                lastUpdatedBy: lastUpdatedBy,
                                blockNumberUpdated: +blockNumberUpdated,
                                conditionTypes: conditionTypes,
                                actorTypeIds: actorTypeIds
                            }];
                }
            });
        });
    };
    return TemplateStoreManager;
}(ContractBase_1.default));
exports.TemplateStoreManager = TemplateStoreManager;
//# sourceMappingURL=TemplateStoreManager.js.map